import { STATUS_TYPE } from '../../../enum';

export interface FindRewardHistory {
  userId: string;
  limit?: number;
  skip?: number;
}

export interface RewardHistoryOrder {
  id: string;
  orderNumber?: string;
  orderDate?: string;
  status?: string;
  totalAmount?: number;
  rewardPointsRedeemed?: number;
  rewardPointsDiscountAmount?: number;
  rewardPointsEarned?: number;
  rewardPointsToEarn?: number;
}

export interface RewardHistoryItem {
  id: string;
  userId: string;
  orderId?: string | null;
  orderReference?: string | null;
  dateTime?: string;
  dateTimeDisplay?: string | null;
  createdAt?: string;
  transactionType?: string;
  transactionTypeLabel?: string;
  reason?: string | null;
  transactionDescription?: string | null;
  points?: number;
  signedPoints?: number;
  rewardPointsCredited?: number;
  rewardPointsDebited?: number;
  cdType?: 'C' | 'D';
  order?: RewardHistoryOrder | null;
}

export interface RewardHistoryResponse {
  balance: number;
  timezone?: string;
  skip?: number;
  limit?: number;
  total: number;
  data: RewardHistoryItem[];
}

export interface InitialState {
  data: RewardHistoryItem[];
  balance: number;
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  balance: 0,
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
